const ROUTE_LABELS = {
    "/": "Моя компания",
    "/begin": "Начало работы",
    "/staff": "Сотрудники",
    "/groups": "Группы",
    "/group": "Группы",
    "/hr/admins": "HR Администраторы",
    "/rating": "Оценка",
    "/detailed": "Сводная таблица",
    "/courses": "Развитие",
    "/instruments": "Ежедневные помощники",
    "/analytics/dashboard": "Мониторинг",
    "/analytics/reports": "Отчёты",
    "/catalog": "Каталог решений",
    "/my-orders": "Заказы",
    "/personal": "Личный кабинет",
    "/my-development": "Моё развитие",
    "/diary": "Дневник эмоций",
    "/diary/analytics": "Аналитика дневника",
    "/mood/tracker": "Навигатор эмоций",
    "/library/list": "Библиотека эмоций",
    "/subscription": "Подписка",
    "/faq": "Помощь с ЛК",
    "/profile": "Профиль",
    "/references/list": "Эталонный профиль",
};

const labelForRoute = (route) => ROUTE_LABELS[route] || route;

const dedupeActions = (actions) => {
    const seen = new Set();
    return actions.filter((item) => {
        const key = item?.url || item?.route;
        if (!key || seen.has(key)) return false;
        seen.add(key);
        return true;
    });
};

const QUOTED_WITH_ROUTE = /«([^»]+)»\s*\(\s*(\/[^)\s]+)\s*\)/g;
const PAREN_ROUTE = /\(\s*(\/[^)\s]+)\s*\)/g;
const BARE_ROUTE = /(?<![\w/])(\/[a-z0-9/_-]+)/gi;

export const extractRoutesFromText = (text) => {
    if (!text) return [];

    const routes = [];

    let match;
    const quoted = new RegExp(QUOTED_WITH_ROUTE.source, "g");
    while ((match = quoted.exec(text)) !== null) {
        routes.push({ label: match[1].trim(), route: match[2] });
    }

    const paren = new RegExp(PAREN_ROUTE.source, "g");
    while ((match = paren.exec(text)) !== null) {
        routes.push({ label: labelForRoute(match[1]), route: match[1] });
    }

    const bare = new RegExp(BARE_ROUTE.source, "gi");
    while ((match = bare.exec(text)) !== null) {
        const route = match[1];
        if (!routes.some((a) => a.route === route)) {
            routes.push({ label: labelForRoute(route), route });
        }
    }

    return dedupeActions(routes);
};

export const stripRoutesFromText = (text) => {
    if (!text) return "";

    return text
        .replace(QUOTED_WITH_ROUTE, "«$1»")
        .replace(PAREN_ROUTE, "")
        .replace(BARE_ROUTE, "")
        .replace(/\s{2,}/g, " ")
        .replace(/ +\n/g, "\n")
        .replace(/\n{3,}/g, "\n\n")
        .trim();
};

export const formatProhorReply = (reply) => {
    if (!reply) return { text: "", actions: [] };

    const explicit = [];
    if (Array.isArray(reply.actions)) explicit.push(...reply.actions);
    if (reply.action) explicit.push(reply.action);

    const fromText = extractRoutesFromText(reply.text);
    const text = stripRoutesFromText(reply.text);

    return {
        text,
        actions: dedupeActions([...explicit, ...fromText]).slice(0, 6),
    };
};
